import {Base} from "@/api/Base"

export class AuthorityList extends Base {
    path = "authority/list"
}